export class CarouselInfo {
    imagesTh: string[];
    imagesEn: string[];
    mobileImagesTh: string[];
    mobileImagesEn: string[];
    links: string[];
}


// WEBPACK FOOTER //
// ./src/app/model/carousel.model.ts